import { computed } from 'vue'
import { useAIAssistantStore } from '@/stores/aiAssistant'
import { useUIStore } from '@/stores/ui'

/**
 * Assistant dock flag shared by every screen that hosts the chat panel.
 * On desktop, while the panel is open, the screen shrinks into an inset card
 * surrounded by the shell strip (assets/styles/assistant-shell.css). Never on
 * a phone: there is no room, the panel covers the whole screen instead.
 */
export function useAssistantShell() {
  const aiAssistant = useAIAssistantStore()
  const uiStore = useUIStore()
  const encapsulated = computed(() => aiAssistant.isOpen && !uiStore.isMobile)
  return { encapsulated }
}
